var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 54,
    viewBox: "0 0 42 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6234 12.4615C23.9531 12.4615 26.8734 10.8137 28.6125 8.61665C30.1875 6.62555 31.3359 3.84488 31.3359 1.06421C31.3359 0.686584 31.3031 0.308964 31.2375 0C28.6453 0.102988 25.5281 1.81945 23.6578 4.11951C22.1812 5.87031 20.8359 8.61666 20.8359 11.4317C20.8359 11.8436 20.9016 12.2556 20.9344 12.3929C21.0984 12.4272 21.3609 12.4615 21.6234 12.4615ZM13.4203 54C16.6031 54 18.0141 51.7686 21.9844 51.7686C26.0203 51.7686 26.9062 53.9313 30.45 53.9313C33.9281 53.9313 36.2578 50.5671 38.4562 47.2715C40.9172 43.4952 41.9344 39.7877 42 39.616C41.7703 39.5474 35.1094 36.698 35.1094 28.6993C35.1094 21.7648 40.3594 18.6408 40.6547 18.4005C37.1766 13.1825 31.8937 13.0451 30.45 13.0451C26.5453 13.0451 23.3625 15.5168 21.3609 15.5168C19.1953 15.5168 16.3406 13.1825 12.9609 13.1825C6.52969 13.1825 0 18.7438 0 29.2486C0 35.7711 2.42812 42.6713 5.41406 47.1341C7.97344 50.9104 10.2047 54 13.4203 54Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.6441106da08fdf4cd3f5696758903935.svg";
export { ForwardRef as ReactComponent };